export const statuses = {
    loading: "LOADING",
    notFound: "NOTFOUND",
    found: "FOUND",
    provisioned: "PROVISIONED",
    error: "ERROR",
    finished: "FINISHED",
}